export default {
  name: "Название юрлица",
  entity: "Юрлицо",
  iik: "ИИК",
  inn: "ИНН",
  bin: "БИН",
  bic: "БИК",
  bankBic: "Бик банка",
  bankMFO: "МФО банка",
  codeFiscal: "Cod Fiscal",
  head_name_description:
    "Введите Ф.И.О. ответственного лица, на которое будут автоматически создаваться акты и счета",
  mainOrganization: "Основное юрлицо",
  mainOrganizationHint:
    "Основное юрлицо используется для покупки тарифа и остается активным при его деактивации. Изменить основное юрлицо можно не чаще чем раз в 14 дней",
  chooseMainOrganization: "Выберите Юр лицо",
  maxOrganizationError: "Создано максимальное количество организаций",
  moderOrganizationError:
    "Вы не можете добавить новую организацию, пока проходит процесс модерации",
  aboutTitle: "Информация о вашей организации",
  typeOrganization: "Тип организации",
  bankName: "Название банка",
  legalAddress: "Юридический адрес",
  currentAccountNumber: "Номер расчетного счета",
  correspondentAccount: "Корсчет",
  vatCode: "Код НДС",
  addressFieldRequired: "Не введен адрес юр.лица",
  metaIsRequired: "Не введены банковские данные",
  add: {
    button: "Создать юрлицо",
  },
  registrationNumber: "Регистрационный номер",
  // popup Aliexpress
  entities: "Юрлица",
  head_name: "Ф.И.О. руководителя",
  ogrn: "ОГРН",
  ogrnOgrnip: "ОГРН / ОГРНИП",
  legalTypes: "Форма юрлица",
  taxSystem: "Тип налогообложения",
  monthlyTurnover: "Размер ежемесячного оборота",
  depositSum: "Сумма депозита",
  okvedLabel: "Основной вид деятельности",
  legalEntityCharter: "Устав юрлица",
  mainEntity: "Основное",
  mainEntityInfo: [
    "Основное юрлицо используется для покупки тарифа и остается активным, если после истечения срока его действия, новый тариф не будет оплачен.",
    "Изменить основное юрлицо можно не чаще 1 раза в 14 дней.",
  ],
  cantCreateModal: {
    title: "Вы создали максимальное количество юрлиц на вашем тарифе",
  },
  deposit: "Депозит",
  enterInnOrEntityName: "Введите ИНН или название юрлица",
  entityCreating: "Создание юрлица",
  updateEntityNotifyMessage: {
    create: "Юрлицо отправлено на модерацию",
    edit: "Данные юрлица успешно изменены",
  },
  commercial: "Коммерческое юрлицо",
  uncommercial: "Некоммерческое юрлицо",
  depositMinSumHint:
    "Минимальный остаток на счете. Сумма не менее {minDeposit} RC, которая остается на балансе при выводе средств.",
  entityType: "Тип юрлица",
  entityInfo: "Информация о юрлице",
  bankDetails: "Банковские реквизиты",
  frequencyMainEntityChanging:
    "Изменить основное юрлицо можно не чаще, чем 1 раз в 14 дней.",
  abailableChangeMainEntity:
    "Смена основного юрлица будет доступна с {nextChangeDate}.",
  mainEntityDescription:
    "Будет использоваться для покупки тарифа и останется активным, если после истечения срока его действия, новый тариф не будет оплачен.",
  entityHasHalal: "Юрлицо имеет сертификат Халяль",
  headNameToSendActs:
    "Ф.И.О. ответственного лица, на которое будут автоматически создаваться акты и счета",
  certHalal: "Сертификат Халяль",
  makeMainEntity: "Сделать {entityName} основным юрлицом?",
  successChangedMainEntity: "Основное юрлицо успешно изменено",
  mainEntityUseForBuyingTariff:
    "Основное юрлицо используется для покупки тарифа и остается активным, если после истечения срока его действия, новый тариф не будет оплачен.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "После нажатия на кнопку «Подтвердить», изменить основное юрлицо еще раз можно будет не ранее, чем через 14 дней.",
  cancelCreationModal: {
    title: "Отменить создание юрлица?",
    subtitle:
      "Заполненные данные не будут сохранены. Чтобы продолжить создание юрлица, нажмите «Назад».",
  },
  pressBackToSave:
    "Нажмите кнопку «Назад», чтобы сохранить изменения или продолжить редактирование.",
  congratulateWithCreateEntity: "Поздравляем с созданием юрлица!",
  entityInModerationNow:
    "В данный момент ваше юрлицо проходит проверку. Она занимает от 24 до 48 часов.",
  toPassModerationPayBill:
    "Для прохождения проверки вам необходимо оплатить счет с указанного юрлица, скачав его по кнопке ниже. Вы также можете найти счет в личном кабинете: в разделе «Мои предприятия» - «Документы» под названием «Тестовый платеж».",
  entityEditingNotAvailabel: "Редактирование юрлица временно недоступно",
  cashPaymentBeingMade:
    "Производятся выплаты денежных средств. В этот период редактирование данных юрлица недоступно.",
  entityHasPointsWithConnectPaymentMethods:
    "У юрлица есть торговые точки с подключенными способами оплаты",
  detailsChangesAvailableOnlyIntoTechHelp:
    "Изменение реквизитов юрлица при подключенных способах оплаты возможно только через техническую поддержку <a href='mailto:hello@rc.city'>hello@rc.city</a>",
  forChangeBankDetailsTellUs:
    "Обратите внимание: для изменения банковских реквизитов в способах оплаты - дополнительно сообщите об этом.",
  uCanChangeOnlyDepositSum:
    "Изменить самостоятельно можно только сумму депозита, нажав на кнопку «Редактировать».",
};
